/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import PostImage from 'app/components/common/PostImage.jsx';
import PostTypeIcon from 'app/components/common/PostTypeIcon.jsx';
import PostListUtilities from 'app/modules/PostListUtilities.jsx';
import ItemCategoryTag from 'app/components/Queue/ItemCategoryTag.jsx';
import * as _ from 'underscore';
import DateDisplay from 'app/components/common/DateDisplay.jsx';
import { Breakpoint } from 'react-socks';

class EverqueuePost extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showMobileControls: false
        };

        this.toggleMobileControls = this.toggleMobileControls.bind(this);

    }

    toggleMobileControls(e) {

        this.setState({
            showMobileControls: !this.state.showMobileControls
        });

    }

    render () {
        let countLabel = parseInt(this.props.item.postCount, 10) === 1 ? 'time' : 'times',
            item = this.props.item,
            comment = null,
            urlReg = /(\b((https?|ftp|file:\/\/)|www[.])[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig,
            deleted = null,
            rowClass = 'item-row queue-item-row',
            postType = PostListUtilities.getPostType(item, this.props),
            categoryDisplay = null,
            category = null,
            nextPostTime = null,
            nextPostDate = new Date(),
            retweet = null,
            constants = this.props.app.config.constants;

        comment = PostListUtilities.generateListComment(item, null);

        if (parseInt(this.props.item.nextPostTs) > 0 && !_.isEmpty(this.props.user)) {
            if (parseInt(this.props.everqueueActive)) {
                nextPostDate.setTime(parseInt(this.props.item.nextPostTs, 10) * 1000);
                if (nextPostDate > new Date().getTime()) {
                    nextPostTime = (
                        <span style={{'marginLeft': '5px'}}>
                            Next eligible to post <DateDisplay dateTime={nextPostDate} dateTimeFormat="relative" user={this.props.user} timezone={this.props.user.detail.timezone}/>
                        </span>
                    );
                }
            }
        }

        if (this.props.item.deleted) {
            rowClass += ' deleted';
            deleted = (
                <div className="item-date queue-item-date">
                    <div className="marked-for-deletion">
                        <i className="icon ion-ios-trash-outline"></i>
                    </div>
                </div>
            );
        }

        if (this.props.item.tagID !== undefined && parseInt(this.props.item.tagID, 10) !== 0) {
            category = _.findWhere(this.props.categories, {id: this.props.item.tagID});
            categoryDisplay = (
                <ItemCategoryTag category={category}/>
            );
        }

        if (this.props.social.psID == constants.POST_SVC_TWITTER && parseInt(this.props.item.postCount, 10) > 0) {
            retweet = (
                <div className="retweet-indicator">
                    <i className='ds-icon icon-retweet'></i>
                </div>
            );
        }

        let title = '',
            body = '';

        if (item.preview.title) {
            title = item.preview.title;
        } else if (item.preview.itemInfo !== undefined && item.preview.itemInfo.title) {
            title = item.preview.itemInfo.title;
        }

        if (!item.preview.comment && !item.preview.status && !item.preview.message) {
            if (item.preview.body) {
                body = item.preview.body;
            } else if (item.preview.itemInfo !== undefined && item.preview.itemInfo.summary) {
                body = item.preview.itemInfo.summary;
            }
        }

        return (
            <div className="everqueue-item">
                <div className="everqueue-item-header">
                    <Breakpoint mobile only>
                        <div className="everqueue-retweet-mobile">
                            {retweet}
                        </div>
                    </Breakpoint>
                    Posted {item.postCount} {countLabel} {nextPostTime}
                </div>
                <div className={rowClass}>
                    <div className="item">
                        {categoryDisplay}
                        <div className="item-image queue-item-image">
                            <PostImage
                                {...this.props}
                                item={item}/>
                            <PostTypeIcon item={item} postType={postType}/>
                        </div>
                        <Breakpoint desktop only>
                            <div className="item-share queue-item-share everqueue">
                                {deleted}
                                <div className="item-controls queue-item-controls">
                                    <div className="item-control queue-item-control" data-itemid={item.id} onClick={this.props.editHandler.bind(null, item)} role="button" aria-label="edit">
                                        <i className="icon ion-ios-compose-outline"></i>
                                    </div>
                                    <div className="item-control queue-item-control" data-itemid={item.id} onClick={this.props.deleteHandler.bind(null, item)} role="button" aria-label="delete">
                                        <i className="icon ion-ios-trash-outline"></i>
                                    </div>
                                </div>
                            </div>
                        </Breakpoint>
                        <Breakpoint mobile only>
                            <div className="mobile-toggle">
                                {(deleted !== null) ? deleted : (
                                    <div className="item-control" onClick={this.toggleMobileControls} role="button" aria-label="show controls">
                                        <i className="icon ion-gear-b"></i>
                                    </div>
                                )}
                            </div>
                        </Breakpoint>
                        <div className="item-details queue-item-details">
                            <div className="item-summary queue-item-summary">
                                <div className="ellipsis item-headline item-title">{title}</div>
                                {comment}
                                <div className="post-preview-body ellipsis item-summary">{body}</div>
                            </div>
                            <Breakpoint desktop only>
                                {retweet}
                            </Breakpoint>
                            <Breakpoint mobile only>
                                {(this.state.showMobileControls === false) ? null : (
                                    <div className="item-controls queue-item-controls">
                                        <div className="item-control queue-item-control" data-itemid={item.id} onClick={this.props.editHandler.bind(null, item)} role="button" aria-label="edit">
                                            <i className="icon ion-ios-compose-outline"></i>
                                        </div>
                                        <div className="item-control queue-item-control" data-itemid={item.id} onClick={function(e) {
                                                this.toggleMobileControls();
                                                this.props.deleteHandler(item, e);
                                            }.bind(this, item)} role="button" aria-label="delete">
                                            <i className="icon ion-ios-trash-outline"></i>
                                        </div>
                                    </div>
                                )}
                            </Breakpoint>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

EverqueuePost.propTypes = {
    item: PropTypes.object,
    editHandler: PropTypes.func,
    deleteHandler: PropTypes.func
};

EverqueuePost.defaultProps = {
    item: {},
    editHandler: () => {},
    deleteHandler: () => {}
};

export default EverqueuePost;
